import { API_URL } from '../api';
const API = API_URL;

async function request(path, { token, method = 'GET', body } = {}) {
  const res = await fetch(`${API}${path}`, {
    method,
    cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) {
    throw Object.assign(new Error(data.error || 'Erreur serveur'), { status: res.status });
  }
  return data;
}

// Admin (jeton requis)
export const adminListServers = (token) => request('/api/admin/servers', { token }).then(d => d.servers);
export const adminSaveServer = (token, id, body) =>
  request(id ? `/api/admin/servers/${id}` : '/api/admin/servers', { token, method: id ? 'PUT' : 'POST', body }).then(d => d.server);
export const adminDeleteServer = (token, id) => request(`/api/admin/servers/${id}`, { token, method: 'DELETE' });
